var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { COLORS } from "../../../../../constants";
import { AutocompleteChip, Text } from "../../../../Atoms";
var Tags = function (_a) {
    var tags = _a.tags, _b = _a.tagsToShow, tagsToShow = _b === void 0 ? 2 : _b;
    var showCountTag = tags.length > tagsToShow;
    var countTagValue = "+".concat(tags.length - tagsToShow);
    return (_jsxs(Stack, __assign({ direction: "row", mt: 2, "data-testid": "table-cell-tags" }, { children: [tags.slice(0, tagsToShow).map(function (tag) { return (_jsx(AutocompleteChip, { option: __assign({}, tag), sx: { mr: 2, mb: 2 } }, tag.id)); }), showCountTag && (_jsx(Text, __assign({ "data-testid": "table-cell-tag-count", variant: "body3", sx: { color: COLORS.SHADED_COBALT } }, { children: countTagValue })))] })));
};
export default Tags;
